export class AverageTrafficSummary {
    costCenterId: number;
    contractTypeId: number;
    groupId: number;
    currentMonthPayIn: number;
    currentMonthPayout: number;
    currentMonthLocationGain: number;
    currentMonthPartnerGain: number;
    last3MonthPayIn: number;
    last3MonthPayout: number;
    last3MonthLocationGain: number;
    last3MonthPartnerGain: number;
    last6MonthPayIn: number;
    last6MonthPayout: number;
    last6MonthLocationGain: number;
    last6MonthPartnerGain: number;

    constructor() { }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/average-traffic/average-traffic.model.ts